import React, { Component } from 'react';
import Spinner from 'react-bootstrap/Spinner'

import '../../css/common/Button.css';

class Button extends Component {

  render() {

    var className   = this.props.className || 'button-default';
    var style       = this.props.style;
    var value       = this.props.value || '';
    var onClick     = this.props.onClick;
    var loading     = this.props.loading || false;
    var disabled    = this.props.disabled || false;
    var hide        = this.props.hide || false;
    var icon        = this.props.icon || '';

    if (loading || disabled) {
      onClick = () => { }
    }

    if (hide) {
      return null;
    }

    return <span className={className + ' button-default'}
                 style={style}
                 onClick={onClick}>
                  { loading ? this.renderSpinner(className) : null }
                  <span className={ icon ? icon : '' } style={{ }}>{ icon ? '' : value}</span>
           </span>

  }

  renderSpinner = (className) => {
    const spinnerColor = className === 'button-clear' || className === 'button-clear-blue' ? '#1dc2ff' : 'white';
    return <Spinner as="span" animation="border" size='sm' style={{ color: spinnerColor, marginRight: 10 }} />
  }

}

export default Button
